import { configureStore } from '@reduxjs/toolkit'

import materialReducer from './materialReducer'
import toolReducer from './toolReducer'
import machineReducer from './machineReducer'


const store = configureStore({
  reducer: {
    material: materialReducer,
    tool: toolReducer,
    machine: machineReducer,
  },
})
export function loadState(item:string, defaultState: any) {
  if (sessionStorage.getItem(`advisor-${item}`) !== null) {
    return JSON.parse(sessionStorage.getItem(`advisor-${item}`) || '{}')
  } else {
    sessionStorage.setItem(`advisor-${item}`, JSON.stringify(defaultState));
    return defaultState;
  }
}
export function saveState(item:string, json: any) {
  sessionStorage.setItem(`advisor-${item}`, JSON.stringify(json));
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store;
